import { css } from '@emotion/core';

import { Colors } from '@zapier/theme';

export const Styles = {
  logo: css`
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 20px;
  `,
  preview: css`
    position: relative;
    border-left: 1px solid ${Colors.adamantium};
    padding: 25px 45px;
    width: 50%;
    max-width: 800px;
    overflow-y: auto;
  `,
  header: css`
    margin-top: 20px;
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  `,
};
